import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Chip,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const PHOTO_STRIPS = [
  "/photobooth/3.gif", // TODO: add photo strip
  "/photobooth/2.gif",
  "/photobooth/3.jpg",
  "/photobooth/4.gif",
];

const PhotoBooth = () => {
  return (
    <>
    <Helmet>
  <title>
    Japanese Photobooth in Ottawa | Photo Memories at Den Den Claw
  </title>

  <meta
    name="description"
    content="Take cute photos at Den Den Claw’s Japanese-style photobooth in Ottawa. Filters, props, and instant memories — perfect for friends, dates, and events."
  />

  <link rel="canonical" href="https://www.dendenclaw.com/explore/photobooth" />

</Helmet>
    <Box sx={{ py: 6 }}>
      <Container maxWidth="md">
        {/* ---------- HEADER ---------- */}
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, textAlign: "center", mb: 2 }}
        >
          Photo Booth 📸
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{
            textAlign: "center",
            maxWidth: 600,
            mx: "auto",
            mb: 6,
            color: "text.secondary",
          }}
        >
          Capture the moment with our Japanese-style photo booth — fun, playful,
          and perfect for making cute memories 💙
        </Typography>

        {/* ---------- HERO IMAGE ---------- */}
        <Box
          component="video"
          src="/photobooth/demo.mp4"
          autoPlay
          muted
          loop
          playsInline
          aria-label="Japanese style photo booth"
          sx={{
            width: "100%",
            maxHeight: 420,
            objectFit: "cover",
            borderRadius: 3,
            mb: 6,
          }}
        />

        {/* ---------- INFO SECTIONS ---------- */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
              How It Works ✨
            </Typography>

            <Typography sx={{ mb: 1 }}>
              Our photo booth features fun filters, stickers, and effects inspired
              by classic Japanese purikura machines.
            </Typography>

            <Typography sx={{ mb: 1 }}>
              You’ll need tokens to use the photo booth, just like our claw
              machines. Tokens can be purchased at the counter.
            </Typography>

            <Typography>
              Once you’re done decorating your photos, you’ll get printed photo
              strips and a QR code to a digital copy to take home as a keepsake!
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: 6,
                p: 3,
                textAlign: "center",
                height: "100%",
              }}
            >
              <CardContent>
                <Chip
                  label="Perfect for Date Nights 💕"
                  color="primary"
                  sx={{ mb: 2, fontWeight: 600 }}
                />

                <Typography sx={{ mb: 1 }}>
                  The photo booth is a favorite for couples and friend groups.
                </Typography>

                <Typography>
                  Strike a pose, use silly props, and walk away with printed
                  memories from your visit to Ottawa's Chinatown.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* ---------- MINI GALLERY ---------- */}

        {/* Mobile carousel */}
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            gap: 2,
            overflowX: "auto",
            pb: 2,
            scrollSnapType: "x mandatory",
            mb: 6,
          }}
        >
          {PHOTO_STRIPS.map((src, idx) => (
            <Box
              key={idx}
              sx={{
                minWidth: 140,
                scrollSnapAlign: "center",
              }}
            >
              <Card sx={{ borderRadius: 3, boxShadow: 4 }}>
                <CardMedia
                  component="img"
                  image={src}
                  alt={`Photo strip ${idx + 1}`}
                />
              </Card>
            </Box>
          ))}
        </Box>

        {/* Desktop grid */}
        <Grid
          container
          spacing={3}
          sx={{ display: { xs: "none", md: "flex" }, mb: 6 }}
        >
          {PHOTO_STRIPS.map((src, idx) => (
            <Grid key={idx} item xs={6} md={3}>
              <Card sx={{ borderRadius: 3, boxShadow: 4 }}>
                <CardMedia
                  component="img"
                  image={src}
                  alt={`Photo strip ${idx + 1}`}
                />
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* ---------- VISIT US CTA ---------- */}
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: 6,
            p: 4,
            textAlign: "center",
            background: "linear-gradient(180deg, #e8f2ff 0%, #f5faff 100%)",
          }}
        >
          <CardContent>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
              Ready to Strike a Pose? ✨
            </Typography>

            <Typography sx={{ mb: 3, color: "text.secondary" }}>
              Pair the photo booth with claw machines, prizes, and events for
              the full Den Den Claw experience.
            </Typography>

            <Button
              variant="contained"
              size="large"
              component={Link}
              to="/contact"
              sx={{
                borderRadius: 999,
                px: 4,
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Visit Us
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
    </>
  );
};

export default PhotoBooth;
